import Vue from "vue";
import Router, { RouteConfig } from "vue-router";
import csroutes from "@/Views/ContentStream/router";
import webroutes from "@/Views/Domain/router";
import configroutes from "@/Views/Domain/ViewerConfiguration/router";
import domainroutes from "@/Views/Domain/Settings/router";
import loginroutes from "@/Login/router";
import adminroutes from "@/Views/Admin/router";
import articleroutes from "@/Views/Articles/router";
import subroutes from "@/Views/Store/router";
import testroutes from "@/tests/router";

Vue.use(Router);

const baseroutes: RouteConfig[] = [
	{
		path: "/:id/home/",
		name: "home",
		component: () => import("@/Views/Home.vue"),
		props: true,
		meta: { name: "Home", page: "account" }
	},
	{
		path: "/plugins/:id/",
		name: "plugins",
		component: () => import("@/Views/Plugins.vue"),
		props: true,
		meta: { name: "Plugins", page: "account" }
	},
	{
		path: "/",
		name: "welcome",
		component: () => import("@/Views/Welcome.vue"),
		props: false,
		meta: { name: "Welcome", page: "none" }
	},
	{
		path: "/:customerAccountId/todo/",
		name: "contentstreamstodo",
		component: () => import("@/Views/ContentStream/ContentStreamTodo.vue"),
		props: true,
		meta: { name: "Content Stream Todo", page: "account" }
	},
	{
		path: "/:id/contentstreams/",
		name: "contentstreams",
		props: true,
		component: () => import("@/Views/ContentStreams.vue"),
		meta: { name: "My Content Streams", page: "account" }
	},
	{
		path: "/contentstreamsubs/:id/",
		name: "contentsubscriptions",
		props: true,
		component: () => import("@/Views/ContentSubscriptions.vue"),
		meta: { name: "My Stream Subscriptions", page: "account" }
	},
	{
		path: "/purchasedarticles/:id/",
		name: "purchasedarticles",
		component: () => import("@/Views/Store/PurchasedArticles.vue"),
		props: true,
		meta: { name: "Purchased Articles", page: "account" }
	},
	{
		path: "/websites/:id/",
		name: "websites",
		props: true,
		component: () => import("@/Views/ParticaWebsites.vue"),
		meta: { name: "My Websites", page: "account" }
	},
	{
		path: "/articles/:id/",
		name: "articles",
		props: true,
		component: () => import("@/Views/Articles/AccountArticles.vue"),
		meta: { name: "Account Articles", page: "account" }
	},
	{
		path: "/written/:id/",
		name: "writtenarticles",
		props: true,
		component: () => import("@/Views/Written/WrittenArticles.vue"),
		meta: { name: "Article Folders", page: "account" }
	},
	{
		path: "/articlelicences/:id/",
		name: "articlelicences",
		props: true,
		component: () => import("@/Views/ArticleLicence/AccountArticleLicences.vue"),
	},
	{
		path: "/users/:id/",
		name: "users",
		props: true,
		component: () => import("@/Views/Users/Users.vue"),
	}
];

// always add to routes last.
const notfoundroute: RouteConfig[] = [
	{ path: "*", component: () => import("@/Views/PageNotFound.vue") }
];

// add routes from our other route files.
const allroutes = baseroutes.concat(
	loginroutes as RouteConfig[],
	csroutes as RouteConfig[],
	webroutes as RouteConfig[],
	adminroutes as RouteConfig[],
	domainroutes as RouteConfig[],
	configroutes as RouteConfig[],
	articleroutes as RouteConfig[],
	subroutes as RouteConfig[],
	testroutes as RouteConfig[],
	// page not found is last
	notfoundroute
);


export default new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: allroutes
});
